import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import TableCell from "@app/analytics/components/Table/TableCell";

import Stack from "@rui/Stack";

export const Description = styled(Typography)(({ theme }) => ({
  color: theme.palette.shades.neutral[600],
  fontSize: "0.875rem",
  lineHeight: 16 / 14,
}));

export const TableCellWithOverflow = styled(TableCell)({
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: 0,
});

export const ModuleTableContainer = styled(Stack)({
  maxWidth: "100%",
  overflow: "auto",
});

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.shades.neutral[700],
}));

export const SectionSubtitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.labelReg,
  color: theme.palette.shades.neutral[500],
}));

export const SectionHeading = styled(Stack)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const Section = styled(Stack)(({ theme }) => ({
  paddingTop: theme.spacing(1),
  [theme.breakpoints.up("mobile")]: {
    border: `1px solid ${theme.palette.shades.neutral[100]}`,
    borderRadius: theme.corners.base,
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(1),
  },
}));
